import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-oauth-callback',
  standalone: true,
  templateUrl: './oauth-callback.component.html',
  styleUrls: ['./oauth-callback.component.css']
})
export class OauthCallbackComponent {
  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private toastr: ToastrService
  ) {
    this.route.queryParams.subscribe(params => {
      const code = params['code'];
  
      if (!code) {
        const redirectUrl = `${environment.centralAuthUrl}?client_id=${environment.centralClientId}&response_type=code&redirect_uri=${encodeURIComponent(environment.centralRedirectUri)}`;
        window.location.href = redirectUrl;
        return;
      }
  
      this.exchangeCodeForToken(code);
    });
  }

  exchangeCodeForToken(code: string) {
    const body = {
      code: code,
      redirect_uri: environment.centralRedirectUri // <-- Deve bater com a URL registrada
    };

    this.http.post<{ token: string }>(`${environment.apiUrl}/auth/login/oauth2/code/central`, body)
      .subscribe({
        next: (response) => {
          sessionStorage.setItem('token', response.token); // <-- Salva token
          sessionStorage.setItem('loginOrigin', 'central'); // <-- Marca origem do login
          this.router.navigate(['/ava-unesp']); // <-- Redireciona para rota protegida
        },
        error: () => {
          this.toastr.error('Erro ao autenticar com a Central de Acessos');
          this.router.navigate(['/login']);
        }
      });
  }
}
